import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function ResourcePage({ title, eyebrow = "Resources", children, testId }) {
  return (
    <main data-testid={testId}>
      <section className="pt-16 md:pt-20 pb-8 md:pb-12 border-b border-navy-100">
        <div className="container-narrow">
          <Link to="/resources" className="inline-flex items-center gap-2 text-[13px] text-navy-500 hover:text-navy-800 transition-colors" data-testid="resource-back">
            <ArrowLeft size={14} /> Back to all resources
          </Link>
          <div className="mt-5 text-[12px] tracking-[0.24em] uppercase text-gold-500 font-medium">{eyebrow}</div>
          <h1 className="font-serif-display text-4xl md:text-6xl text-navy-800 mt-3 leading-[1.05] tracking-tight">{title}</h1>
        </div>
      </section>
      <section className="py-10 md:py-16">
        <div className="container-narrow">{children}</div>
      </section>
    </main>
  );
}
